export class PictureTextGrid {
    constructor() {
        /*                   */
    }
}
